export default {
  extraSmall: {
    width: '1.5rem',
    height: '1.5rem',
  },
  small: {
    width: '2.8125rem',
    height: '2.8125rem',
  },
  medium: {
    width: '3.75rem',
    height: '3.75rem',
  },
  large: {
    width: '5.625rem',
    height: '5.625rem',
  },
  circle: {
    border: {
      style: 'solid',
      thickness: '0.1875rem',
      radius: '50%',
    },
    padding: {
      top: '0.625rem',
      right: '0.625rem',
      bottom: '0.625rem',
      left: '0.625rem',
    },
  },
};
